const BASE_ROUTE = '/companies-root'

export const ROUTE_NAMES = {
  LIST: 'companies-list',
  DETAILS: 'companies-details',
  CONFIG: 'companies-config',
  EDIT: 'companies-edit'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'companies'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: ':crn'
  },
  [ROUTE_NAMES.CONFIG]: {
    name: ROUTE_NAMES.CONFIG,
    path: ':id/config'
  },
  [ROUTE_NAMES.EDIT]: {
    name: ROUTE_NAMES.EDIT,
    path: ':id/admin'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view/>',
      name: 'CompaniesModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS].name,
        path: ROUTES[ROUTE_NAMES.DETAILS].path,
        component: (resolve) => require(['./views/details'], resolve),
        props: true
      },
      {
        name: ROUTES[ROUTE_NAMES.CONFIG].name,
        path: ROUTES[ROUTE_NAMES.CONFIG].path,
        component: (resolve) => require(['./views/config'], resolve),
        props: true
      },
      {
        name: ROUTES[ROUTE_NAMES.EDIT].name,
        path: ROUTES[ROUTE_NAMES.EDIT].path,
        component: (resolve) => require(['./views/edit'], resolve),
        props: true
      }
    ]
  }
]
